exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-comp:not(.active){opacity:0;visibility:hidden}.popup-comp .close{right:0;top:0;-webkit-transform:translate(50%,-50%);transform:translate(50%,-50%)}.popup-comp .content{width:100%;max-width:600px;margin:auto}.popup-comp .selector-comp{padding:12px;max-height:100vh;overflow-y:scroll}", ""]);

// exports
